/* eslint-disable prefer-destructuring,func-names,react/prop-types  */
import React, { Component } from 'react';
import { version, releaseDate } from '../../../package.json';
import MetaView from './MetaView';

const ENV = process.env.NODE_ENV;
const RELEASE_VERSION = process.env.branch;

export default class MetaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { version: RELEASE_VERSION || version || '??', date: releaseDate || '??', env: ENV };
  }

  componentDidCatch(error, info) {
    console.log('error:', error, info);
    // Display fallback UI
    this.setState({ hasError: error.message });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          {' '}
--- error in metaView --
          {this.state.error}
          {' '}

        </div>
      );
    }
    return (
      <MetaView {...this.state} />
    );
  }
}
